import React from "react";
import { Button } from "antd";
import { BookingTransaction } from "../../../interfaces/booking.interface";
import { humanize, parseCurrencyString } from "../../../utils/helpers";

const CheckmarkSVG = () => (
  <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#paysuccess-check-clip)">
      <path d="M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z" fill="url(#paysuccess-check-a)"/>
      <path d="M64.6836 31.5058L43.4512 52.7344L35.3164 44.5996C33.9248 43.2101 32.0387 42.4297 30.0722 42.4297C28.1058 42.4297 26.2197 43.2101 24.8281 44.5996C23.4386 45.9911 22.6582 47.8772 22.6582 49.8437C22.6582 51.8102 23.4386 53.6963 24.8281 55.0879L37.7441 68.0039C37.8828 68.1699 38.0293 68.332 38.1855 68.4883C39.5846 69.8793 41.4773 70.6601 43.4502 70.6601C45.4231 70.6601 47.3158 69.8793 48.7148 68.4883C48.8711 68.332 49.0176 68.1699 49.1562 68.0039L75.1719 41.9922C76.5613 40.6006 77.3418 38.7145 77.3418 36.748C77.3418 34.7815 76.5613 32.8954 75.1719 31.5039C73.78 30.1147 71.8938 29.3346 69.9273 29.335C67.9608 29.3353 66.0749 30.1161 64.6836 31.5058Z" fill="white"/>
    </g>
    <defs>
      <linearGradient id="paysuccess-check-a" x1="-0.398634" y1="-0.398241" x2="96.5623" y2="96.5627" gradientUnits="userSpaceOnUse">
        <stop stopColor="#16E585"/>
        <stop offset="1" stopColor="#00BD65"/>
      </linearGradient>
      <clipPath id="paysuccess-check-clip">
        <rect width="100" height="100" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);

const CalendarSVG = () => (
  <svg width="72" height="78" viewBox="0 0 91 98" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M31.6875 51.1875H21.9375C20.5913 51.1875 19.5 52.2788 19.5 53.625V63.375C19.5 64.7212 20.5913 65.8125 21.9375 65.8125H31.6875C33.0337 65.8125 34.125 64.7212 34.125 63.375V53.625C34.125 52.2788 33.0337 51.1875 31.6875 51.1875Z" fill="#FFD5BF"/>
    <path d="M31.6875 75.5625H21.9375C20.5913 75.5625 19.5 76.6538 19.5 78V87.75C19.5 89.0962 20.5913 90.1875 21.9375 90.1875H31.6875C33.0337 90.1875 34.125 89.0962 34.125 87.75V78C34.125 76.6538 33.0337 75.5625 31.6875 75.5625Z" fill="#FFD5BF"/>
    <path d="M56.0625 51.1875H46.3125C44.9663 51.1875 43.875 52.2788 43.875 53.625V63.375C43.875 64.7212 44.9663 65.8125 46.3125 65.8125H56.0625C57.4087 65.8125 58.5 64.7212 58.5 63.375V53.625C58.5 52.2788 57.4087 51.1875 56.0625 51.1875Z" fill="#FFD5BF"/>
    <path d="M56.0625 75.5625H46.3125C44.9663 75.5625 43.875 76.6538 43.875 78V87.75C43.875 89.0962 44.9663 90.1875 46.3125 90.1875H56.0625C57.4087 90.1875 58.5 89.0962 58.5 87.75V78C58.5 76.6538 57.4087 75.5625 56.0625 75.5625Z" fill="#FFD5BF"/>
    <path d="M70.6875 51.1875C69.3469 51.1875 68.25 52.2843 68.25 53.625V63.375C68.25 64.3743 68.8594 65.2275 69.7125 65.5931C73.1006 61.5712 77.6831 58.5731 82.875 57.0862V53.6006C82.875 52.26 81.7781 51.1631 80.4375 51.1631H70.6875V51.1875Z" fill="#FFD5BF"/>
    <path d="M90.1875 60.9375C78.0975 60.9375 68.25 70.785 68.25 82.875C68.25 94.965 78.0975 104.812 90.1875 104.812C102.278 104.812 112.125 94.965 112.125 82.875C112.125 70.785 102.278 60.9375 90.1875 60.9375ZM90.1875 75.5625C86.1656 75.5625 82.875 78.8531 82.875 82.875C82.875 84.2156 81.7781 85.3125 80.4375 85.3125C79.0969 85.3125 78 84.2156 78 82.875C78 76.1475 83.46 70.6875 90.1875 70.6875C91.5281 70.6875 92.625 71.7844 92.625 73.125C92.625 74.4656 91.5281 75.5625 90.1875 75.5625Z" fill="url(#paysuccess-cal-a)"/>
    <path d="M69.5175 99.9375H14.625C11.9437 99.9375 9.75 97.7438 9.75 95.0625V41.4375H92.625V56.1844C94.3069 56.3306 95.9156 56.6475 97.5 57.1106V29.25C97.5 23.8631 93.1369 19.5 87.75 19.5H82.875V14.625C82.875 13.2844 81.7781 12.1875 80.4375 12.1875C79.0969 12.1875 78 13.2844 78 14.625V19.5H68.25V14.625C68.25 13.2844 67.1531 12.1875 65.8125 12.1875C64.4719 12.1875 63.375 13.2844 63.375 14.625V19.5H53.625V14.625C53.625 13.2844 52.5281 12.1875 51.1875 12.1875C49.8469 12.1875 48.75 13.2844 48.75 14.625V19.5H39V14.625C39 13.2844 37.9031 12.1875 36.5625 12.1875C35.2219 12.1875 34.125 13.2844 34.125 14.625V19.5H24.375V14.625C24.375 13.2844 23.2781 12.1875 21.9375 12.1875C20.5969 12.1875 19.5 13.2844 19.5 14.625V19.5H14.625C9.23812 19.5 4.875 23.8631 4.875 29.25V95.0625C4.875 100.449 9.23812 104.812 14.625 104.812H74.8313C72.8569 103.423 71.0775 101.79 69.5419 99.9375H69.5175Z" fill="url(#paysuccess-cal-b)"/>
    <defs>
      <linearGradient id="paysuccess-cal-a" x1="68.25" y1="67.1872" x2="83.7453" y2="107.301" gradientUnits="userSpaceOnUse">
        <stop stopColor="#FFB591" stopOpacity="0.56"/>
        <stop offset="1" stopColor="#FFF0E3"/>
      </linearGradient>
      <linearGradient id="paysuccess-cal-b" x1="5" y1="17.5" x2="36.4471" y2="92.5503" gradientUnits="userSpaceOnUse">
        <stop stopColor="#FFB091" stopOpacity="0.8"/>
        <stop offset="1" stopColor="#FFF0E3"/>
      </linearGradient>
    </defs>
  </svg>
);

const TicketDivider = () => (
  <div className="v3-payment-success_ticket-notch">
    <span className="v3-payment-success_ticket-notch-circle" />
    <span className="v3-payment-success_ticket-notch-line" />
    <span className="v3-payment-success_ticket-notch-circle" />
  </div>
);

const STATUS_CONFIG = {
  paid: {
    icon: <CheckmarkSVG />,
    title: "Payment Successful",
    titleColor: "#00BD65",
    message: "Thank you for your booking. A confirmation email has been sent to your inbox.",
  },
  pending: {
    icon: <img src="/iceholidays-assets/images/v3/payment-pending.svg" width={100} height={100} alt="Pending" />,
    title: "Pending Payment",
    titleColor: "#DD741D",
    message: "Payment is currently pending. Your booking will not be confirmed until the payment is successfully processed.",
  },
  failed: {
    icon: <img src="/iceholidays-assets/images/v3/payment-failed.svg" width={100} height={100} alt="Failed" />,
    title: "Payment Failed",
    titleColor: "#DC1A22",
    message: "Your payment could not be completed. Your booking has not been confirmed. Please retry the payment process to secure your reservation.",
  },
} as const;

interface Props {
  transaction: BookingTransaction;
  status: "paid" | "pending" | "failed";
  countdown?: number;
  onRetry?: () => void;
}

const PaymentSuccessV3: React.FC<Props> = ({ transaction, status, onRetry }) => {
  const { summary } = transaction;
  const config = STATUS_CONFIG[status] ?? STATUS_CONFIG.failed;
  const isPaid = status === "paid";
  const isFailed = status === "failed";
  // currencyBalance/currencyDeposit are formatted strings (e.g. "RM 0.00"),
  // so parse the numeric value to detect a genuinely zero outstanding balance.
  const balanceValue = summary?.currencyBalance ? parseCurrencyString(summary.currencyBalance) : 0;
  const hasOutstanding = isPaid && balanceValue > 0;
  const isFullyPaid = isPaid && !!summary?.currencyBalance && balanceValue <= 0;
  const hasDeposit = isPaid && !!(summary?.currencyDeposit);

  return (
    <div className="v3-payment-success">
      <div className="v3-payment-success_header">
        {config.icon}
        <span className="v3-payment-success_title" style={{ color: config.titleColor }}>
          {config.title}
        </span>
        <span className="v3-payment-success_amount">{transaction.bookingFee}</span>
        <span className="v3-payment-success_date">{transaction.transactionDate}</span>
        <span className="v3-payment-success_subtitle">{config.message}</span>
      </div>

      <div className="v3-payment-success_body">
        {hasOutstanding && (
          <div className="v3-payment-success_balance-card">
            <div className="v3-payment-success_balance-label">Outstanding balance</div>
            <div className="v3-payment-success_balance-amount">{summary.currencyBalance}</div>
            <div className="v3-payment-success_balance-due">
              Final payment due before <strong>{summary.finalPaymentDate}</strong>
            </div>
            <div className="v3-payment-success_balance-watermark">
              <CalendarSVG />
            </div>
          </div>
        )}

        {isFullyPaid && (
          <div className="v3-payment-success_balance-card v3-payment-success_balance-card--paid">
            <div className="v3-payment-success_balance-label">Outstanding balance</div>
            <div className="v3-payment-success_balance-amount">{summary.currencyBalance}</div>
            <div className="v3-payment-success_balance-due">
              Fully paid — no further payment required
            </div>
            <div className="v3-payment-success_balance-watermark">
              <CalendarSVG />
            </div>
          </div>
        )}

        <div className="v3-payment-success_details-card">
          <div className="v3-payment-success_tour-name">{summary?.tourName}</div>

          <TicketDivider />

          <div className="v3-payment-success_row">
            <span className="v3-payment-success_row-label">Reference No.</span>
            <span className="v3-payment-success_row-value">{transaction.refNo}</span>
          </div>
          <div className="v3-payment-success_row">
            <span className="v3-payment-success_row-label">Payment Method</span>
            <span className="v3-payment-success_row-value">{transaction.paymentMethod}</span>
          </div>
          <div className="v3-payment-success_row">
            <span className="v3-payment-success_row-label">Tour Code</span>
            <span className="v3-payment-success_row-value">
              {summary?.tourCode}
              {summary?.country && (
                <span className="v3-payment-success_country-badge">{summary.country}</span>
              )}
            </span>
          </div>
          <div className="v3-payment-success_row">
            <span className="v3-payment-success_row-label">Departure Date</span>
            <span className="v3-payment-success_row-value">{summary?.departureDate}</span>
          </div>

          {summary?.fareBreakdown && (
            <>
              <TicketDivider />
              <div className="v3-payment-success_breakdown-header">Fare Breakdown</div>
              <div className="v3-payment-success_breakdown-label">{humanize(summary.fareBreakdown.promo)}</div>
              {summary.fareBreakdown.items.map(item => (
                <div key={item.id} className="v3-payment-success_breakdown-row">
                  <span>{item.category} x {item.count}</span>
                  <span>{summary.priceCurrency} {Number(item.sum).toLocaleString("en-MY", { minimumFractionDigits: 2 })}</span>
                </div>
              ))}
              {summary.currencyAdminFee && (
                <div className="v3-payment-success_breakdown-row">
                  <span>Admin Fee</span>
                  <span>{summary.currencyAdminFee}</span>
                </div>
              )}
              <div className="v3-payment-success_breakdown-row v3-payment-success_grand-total">
                <span>Grand Total</span>
                <span>{summary.currencyGrandTotal || `${summary.priceCurrency} ${Number(summary.fareBreakdown.total).toLocaleString("en-MY", { minimumFractionDigits: 2 })}`}</span>
              </div>
              {hasDeposit && (
                <div className="v3-payment-success_breakdown-row v3-payment-success_deposit">
                  <span>{hasOutstanding ? "Deposit Paid" : "Paid"}</span>
                  <span>-{summary.currencyDeposit}</span>
                </div>
              )}
              {hasOutstanding && (
                <div className="v3-payment-success_breakdown-row v3-payment-success_remaining">
                  <span>Remaining Balance</span>
                  <span>{summary.currencyBalance}</span>
                </div>
              )}
            </>
          )}
        </div>
      </div>

      <div className={`v3-payment-success_footer${isFailed ? " v3-payment-success_footer--row" : ""}`}>
        {isFailed ? (
          <>
            <Button
              block
              size="large"
              style={{ borderRadius: 8, flex: 1 }}
              onClick={() => { sessionStorage.removeItem('ice_v3_payment'); location.href = "/web"; }}
            >
              Back to Home
            </Button>
            <Button
              type="primary"
              block
              size="large"
              style={{ borderRadius: 8, flex: 1 }}
              onClick={onRetry}
            >
              Retry Payment
            </Button>
          </>
        ) : (
          <Button
            type="primary"
            block
            size="large"
            style={{ borderRadius: 8 }}
            onClick={() => { sessionStorage.removeItem('ice_v3_payment'); location.href = "/web"; }}
          >
            Back to Home
          </Button>
        )}
      </div>
    </div>
  );
};

export default PaymentSuccessV3;
